import authInstance from 'config/axios.config';

export const socialMediaServices = {
  getSocialMediaLinks: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== '') params.append(key, String(value));
    });
    const res = await authInstance.post(`/admin/social-media-links?${params}`);
    return res.data;
  },

  addSocialMediaLink: async (data) => {
    const res = await authInstance.post('/admin/social-media', data);
    return res.data;
  },

  updateSocialMediaLink: async ({ id, data }) => {
  const res = await authInstance.patch(`/admin/social-media/${id}`, data);
  return res.data;
},

deleteSocialMediaLink: async (id) => {
  const res = await authInstance.delete(`/admin/social-media/${id}`);
  return res.data;
},
};